const booking = {
  bookingInformation: "Informations de réservation", // translated
  ourCancellationPolicy: "Notre politique d'annulation", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "Cela remplace toute politique d'annulation dans les remarques ci-dessus", // translated
  thisBookingIsNonNefundable: "Cette réservation est non remboursable", // translated
  paymentTerms: "Modalités de paiement", // translated
  paymentWillBeTakenFromYourDefault: "Le paiement sera prélevé sur votre défaut", // translated
  paymentMethod: "mode de paiement", // translated
  afterTheFreeCancellationPeriodIfApplicable: "après la période d'annulation gratuite le cas échéant", // translated
  prebook: "Pré-réservation", // translated
  guests: "Invités", // translated
  payment: "Paiement", // translated
  byClicking: "En cliquant", // translated
  youAreAgreeingToOur: "vous acceptez notre", // translated
  termsAndConditions: "Termes et conditions", // translated
  lastBookableDate: "Dernière date de réservation", // translated
  request: "Demande", // translated
  customerRemarksTextfield: "Remarques du client", // translated
};


export default booking;
